var _effectorFileName = "/builds/gmini/front-common/src/components/ImportErrorTooltip/ImportErrorTooltip.tsx";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { CloudOff, ArrowRight } from '@gmini/ui-kit';
import { Tooltip } from '@mui/material';
import { Wrapper, Body, Description, Anchor, Title } from "./ImportErrorTooltip.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ImportErrorTooltip = function ImportErrorTooltip(_ref) {
  var errorText = _ref.errorText,
      description = _ref.description,
      version = _ref.version,
      children = _ref.children;
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsxs(Wrapper, {
      children: [/*#__PURE__*/_jsxs(Title, {
        children: [/*#__PURE__*/_jsx(CloudOff, {}), "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 v", version]
      }), /*#__PURE__*/_jsx(Body, {
        children: errorText
      }), /*#__PURE__*/_jsx(Description, {
        children: description
      }), /*#__PURE__*/_jsxs(Anchor, {
        target: "_blank",
        href: "https://gmini.freshdesk.com/a/solutions/articles/67000697254",
        children: ["\u041E\u0431\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043C\u043E\u0434\u0435\u043B\u0438 ", /*#__PURE__*/_jsx(ArrowRight, {})]
      })]
    }),
    children: children
  });
};